import React from 'react';
import { Stack } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';

function srcset(image: string) {
  return {
    src: `https://digiarchiv.aiscr.cz/api/img/medium?size=medium&id=${image}`,
    srcSet: `https://digiarchiv.aiscr.cz/api/img/medium?size=medium&id=${image} 2x`,
  };
}

const ImageMasonry = ({ images }) => {
  const intl = useIntl();

  return images && images.length > 0 ? (
    <Stack>
      {images.map((item, index) => (
        <img
          {...srcset(item)}
          key={item}
          alt={intl.formatMessage(
            {
              id: 'image.find.alt',
              defaultMessage: 'Find image {number}',
            },
            { number: index + 1 }
          )}
          loading="lazy"
        />
      ))}
    </Stack>
  ) : (
    <div>
      <FormattedMessage
        id="image.noneUploaded"
        defaultMessage="No images uploaded."
      />
    </div>
  );
};

export { ImageMasonry };
